/**
 * AI 助手技能的纯逻辑：示例提问的文本互转与保存前校验。
 * 与后端 ConfigServiceImpl.validateAiChatSkills 的规则保持一致，
 * 目的是在提交前给出准确提示，而不是替代后端校验。
 */
import { AI_SKILL_LIMITS, AiChatSkill } from '../../../api/aiAssistant';

/** 多行文本 → 示例提问数组（丢掉空行） */
export function parseExamples(text: string): string[] {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

/** 示例提问数组 → 多行文本（编辑框展示） */
export function formatExamples(examples?: string[]): string {
  return (examples || []).join('\n');
}

/**
 * 校验技能列表，返回第一条错误消息；全部合法返回 null。
 * 只校验能在前端确定的规则，长度上限由输入框 maxLength 兜住。
 */
export function validateSkills(skills?: AiChatSkill[]): string | null {
  const list = skills || [];
  if (list.length > AI_SKILL_LIMITS.maxSkills) {
    return `技能最多 ${AI_SKILL_LIMITS.maxSkills} 个`;
  }
  const names = new Set<string>();
  for (const skill of list) {
    const name = (skill.name || '').trim();
    if (!name) {
      return '技能名称不允许为空';
    }
    if (name.length > AI_SKILL_LIMITS.maxNameChars) {
      return `技能名称不能超过 ${AI_SKILL_LIMITS.maxNameChars} 个字符：${name}`;
    }
    if (names.has(name)) {
      return `技能名称重复：${name}`;
    }
    names.add(name);
    if (!(skill.prompt || '').trim()) {
      return `技能提示词不允许为空：${name}`;
    }
    if ((skill.prompt || '').length > AI_SKILL_LIMITS.maxPromptChars) {
      return `技能提示词不能超过 ${AI_SKILL_LIMITS.maxPromptChars} 个字符：${name}`;
    }
    if ((skill.description || '').length > AI_SKILL_LIMITS.maxDescriptionChars) {
      return `技能说明不能超过 ${AI_SKILL_LIMITS.maxDescriptionChars} 个字符：${name}`;
    }
    const examples = skill.examples || [];
    if (examples.length > AI_SKILL_LIMITS.maxExamples) {
      return `技能示例提问最多 ${AI_SKILL_LIMITS.maxExamples} 条：${name}`;
    }
    if (examples.some((example) => example.length > AI_SKILL_LIMITS.maxExampleChars)) {
      return `技能示例提问不能超过 ${AI_SKILL_LIMITS.maxExampleChars} 个字符：${name}`;
    }
  }
  return null;
}
